import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import offerV2SettlementReducer from '../reducers/offerV2SettlementReducer';

const configureStore = (railsProps) => (
  createStore(offerV2SettlementReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
